export const DEFAULT_DATE_FORMAT = 'MM-dd-yyyy';
export const DEFAULT_TIME_ZONE_NAME = 'America/New_York';
export const FIRST_HOUR_DAY = '00:00:00';
export const HH_MM_A_FORMAT = 'hh:mm a';
export const HH_MM_SS_FORMAT = 'HH:mm:ss';
export const ISO_MILISECONDS_FORMAT = 'yyyy-mm-ddTHH:mm:ss.SSSSSSSSS';
export const ISO_STANDARD_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const LAST_HOUR_DAY = '23:59:59';
export const UNIVERSAL_DATE_FORMAT = 'yyyy-MM-dd';
